import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus, faTimesCircle } from '@fortawesome/free-solid-svg-icons';

import { RoundedButton, type RoundedButtonProps } from '../../form/Button';

export const inlineFieldGroupClasses = 'flex flex-wrap gap-x-5 gap-y-2.5';

interface RowManagerLike {
    addRow: () => void;
    removeRow: (index: number) => void;
}

type AddRowButtonProps = Omit<RoundedButtonProps, 'onClick' | 'type' | 'variant'> & {
    disabled?: boolean;
    manager: RowManagerLike;
};

export function AddRowButton({ manager, ...props }: AddRowButtonProps): JSX.Element {
    return (
        <RoundedButton
            type="button"
            variant="icon"
            onClick={() => {
                manager.addRow();
            }}
            {...props}
        >
            <FontAwesomeIcon icon={faPlus} size="sm" />
            <span>{gettext('ADD_ROW')}</span>
        </RoundedButton>
    );
}
interface DeleteRowButtonProps {
    disabled?: boolean;
    manager: RowManagerLike;
    index: number;
}

export function DeleteRowButton({ disabled, manager, index }: DeleteRowButtonProps): JSX.Element {
    return (
        <div>
            <button
                type="button"
                disabled={disabled}
                aria-label={gettext('REMOVE')}
                onClick={() => {
                    manager.removeRow(index);
                }}
            >
                <FontAwesomeIcon icon={faTimesCircle} className="text-error" />
            </button>
        </div>
    );
}
